import { render, staticRenderFns } from "./studioDashboardOpeningHours.vue?vue&type=template&id=4cd3c112&scoped=true"
import script from "./studioDashboardOpeningHours.vue?vue&type=script&lang=js"
export * from "./studioDashboardOpeningHours.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardOpeningHours.vue?vue&type=style&index=0&id=4cd3c112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd3c112",
  null
  
)

export default component.exports